const TaxRollSummaryCollectionHeaders = [
  {
    text: 'Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax District',
    value: 'schoolDistrict',
    sortable: false,
  },
  {
    text: 'Original',
    value: 'originalTax',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Supplement',
    value: 'supplements',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Plus Adj',
    value: 'plusAdj',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Minus Adj',
    value: 'minusAdj',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Adj Taxroll',
    value: 'adjTax',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Collections',
    value: 'collections',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Protest',
    value: 'protest',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Over Payment',
    value: 'overpaid',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Uncollected',
    value: 'uncollected',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Calc Adjust',
    value: 'calcAdjust',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Calc Un Coll',
    value: 'calcUnColl',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

const MortgageCodesHeader = [
  {
    text: 'Code',
    value: 'mtgCode',
    sortable: true,
  },
  {
    text: 'Mortgage Company',
    value: 'mtgCoName',
    sortable: true,
  },
];

const taxAdjTypesHeader = [
  {
    text: 'Adj Type',
    value: 'adjType',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
  {
    text: 'Assessor Code',
    value: 'assessorCodes',
    sortable: false,
  },
  {
    text: 'Supplement',
    value: 'supplement',
    sortable: false,
  },
];

const taxStatusCodesHeader = [
  {
    text: 'Status Code',
    value: 'statusCode',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
];

const TaxStreetsHeaders = [
  {
    text: 'Street Name',
    value: 'streetName',
  },
  {
    text: 'Count',
    value: 'count',
  },
];

const FeeTypesHeaders = [
  {
    text: 'Fee Number',
    value: 'feeNumber',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
  {
    text: 'To Unit',
    value: 'toUnit',
    sortable: false,
  },
];

const TaxAdditionsHeaders = [
  {
    text: 'Addit Code',
    value: 'additionCode',
    sortable: true,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: true,
  },
  {
    text: 'Tax District',
    value: 'taxDistrict',
    sortable: false,
  },
  {
    text: 'Section',
    value: 'section',
    sortable: false,
  },
  {
    text: 'Township',
    value: 'townShip',
    sortable: false,
  },
  {
    text: 'Range',
    value: 'range',
    sortable: false,
  },
  {
    text: 'Quarter',
    value: 'quarter',
    sortable: false,
  },
];

const ProtestedTaxHeaders = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax Id',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Tax District',
    value: 'schoolDistrict',
    sortable: false,
  },
  {
    text: 'Owner Name',
    value: 'ownerName',
    sortable: false,

  },
  {
    text: 'Shared Fund',
    value: 'fundNo',
    sortable: false,
    align: 'right',
    class: 'with-divider-left',
    enableLine: true,
  },
  {
    text: 'Fund Balance',
    value: 'fundAmount',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Total Amt',
    value: 'taxDue',
    sortable: false,
    formatter: 'amount',
    align: 'right',
    class: 'with-divider-left',
    enableLine: true,
  },
  {
    text: 'Total Paid',
    value: 'totalPaid',
    sortable: false,
    formatter: 'amount',
    align: 'right',
  },
  {
    text: 'Amt Under Protest',
    value: 'amountPaidUnderProtest',
    sortable: false,
    formatter: 'amount',
    align: 'right',

  },
  {
    text: 'Refund To TaxPayer',
    value: 'refundToTaxPayer',
    sortable: false,
    formatter: 'amount',
    align: 'right',
    class: 'with-divider-left',
    enableLine: true,
  },
  //
  {
    text: 'Amt Released To Apportion',
    value: 'releaseToApportion',
    sortable: false,
    formatter: 'amount',
    align: 'right',

  }, {
    text: 'Interest Refund Amt',
    value: 'interestOfRefund',
    sortable: false,
    align: 'right',
    class: 'with-divider-left',
    enableLine: true,
    formatter: 'amount',
  }, {
    text: 'Interest Release Amt',
    value: 'interestOfRelease',
    sortable: false,
    align: 'right',
    formatter: 'amount',

  }, {
    text: 'Total Refund',
    value: 'totalRefund',
    sortable: false,
    formatter: 'amount',
    align: 'right',
    class: 'with-divider-left',
    enableLine: true,
  },
  {
    text: 'Total Release',
    value: 'totalRelease',
    sortable: false,
    formatter: 'amount',
    align: 'right',

  },
  {
    text: 'Resolved',
    value: 'resolved',
    sortable: false,
    class: 'with-divider-left',
    enableLine: true,
    formatter: 'flagToYorEmpty',
    align: 'center',
  },
  {
    text: 'Released Date',
    value: 'releasedDate',
    sortable: false,
    formatter: 'shortDate',
    align: 'center',
  },
];
const tifDistrictsHeaders = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    sortable: false,
  },

  {
    text: 'TIF Tax District',
    value: 'tifTaxDistrict',
    sortable: true,
  },
  {
    text: 'Description',
    value: 'description',
    sortable: false,
  },
  {
    text: 'City',
    value: 'city',
    sortable: true,
  },
  {
    text: 'Distribution Tax District',
    value: 'distributionTaxDistrict',
    sortable: false,

  },
  {
    text: 'Base Value',
    value: 'baseValue',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Levy',
    value: 'levy',
    sortable: false,
    formatter: 'amount',
  },
  {
    text: 'Target Amount',
    value: 'targetAmount',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Collection',
    value: 'collections',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Distribution',
    value: 'distributions',
    sortable: false,
    formatter: 'amount',
  },
  {
    text: '% Of Overage to TIF',
    value: 'overgaeToTif',
    sortable: false,
    align: 'overageToTif',
    formatter: 'amount',
  },
];
const newTaxRollHeaders = [
  {
    text: 'Tax Year',
    value: 'taxYear',
    sortable: false,
  },
  {
    text: 'Tax ID',
    value: 'taxId',
    sortable: false,
  },
  {
    text: 'Gross Assessed',
    value: 'grossAssessedValue',
    sortable: false,
    align: 'right',
  },
  {
    text: 'Net Assessed',
    value: 'netAssessedValue',
    sortable: false,
    align: 'right',
  },
  {
    text: 'MIll Code',
    value: 'assessorTaxDistrictCode',
    sortable: false,
    class: 'with-divider-left',
  },
  {
    text: 'Levy',
    value: 'totalLevyMills',
    formatter: 'amount',
    sortable: false,
    align: 'right',
  },
  {
    text: 'Tax Amount',
    value: 'totalTax',
    sortable: false,
    formatter: 'amount',
    align: 'right',
  },
  {
    text: 'Tax District',
    value: 'treasurerTaxDistrictCode',
    sortable: false,
    class: 'with-divider-left',
  },
  {
    text: 'Levy',
    value: 'treasurerLevies',
    formatter: 'amount',
    sortable: false,
    align: 'right',
  },
  {
    text: 'Tax Amount',
    value: 'treasurerTaxAmt',
    formatter: 'amount',
    sortable: false,
    align: 'right',
  },
  {
    text: 'Message',
    value: 'message',
    sortable: false,
    class: 'with-divider-left',
  },
];

const accessorXRefHeaders = [
  {
    text: 'Assesor Mill Code',
    value: 'assessorTaxDistrictCode',
    sortable: false,
  },
  {
    text: 'Our Tax District',
    value: 'taxDistrictCode',
    sortable: false,
  },
  {
    text: 'Description',
    value: 'taxDistrictDescription',
    sortable: false,
  },
  {
    text: 'Assr Levies',
    value: 'assessorLevies',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
  {
    text: 'Treasurer Levies',
    value: 'treasuresLevies',
    sortable: false,
    align: 'right',
    formatter: 'amount',
  },
];

const assessorFireTaxXRefHeaders = [
  {
    text: 'Code',
    value: 'fireDistrict',
    sortable: false,
  },
  {
    text: 'Millage',
    value: 'millage',
    sortable: false,
  },
  {
    text: 'Original Tax District',
    value: 'originalTaxDistrict',
    sortable: false,
  },
  {
    text: 'Tax District with Fire',
    value: 'taxDistrictWithFire',
    sortable: false,
  },
];

const mergeNFinalizeHeaders = [
  {
    text: '',
    value: 'whichRecords',
    sortable: false,
  },
  {
    text: 'Tax/Owner',
    value: 'taxOrOwnerCount',
    sortable: false,
    align: 'right',
  },
  {
    text: 'Summary',
    value: 'summaryCount',
    sortable: false,
    align: 'right',
  },
  {
    text: 'Comments',
    value: 'commentsCount',
    sortable: false,
    align: 'right',
  },
];

const newTaxRollMainHeaders = {
  MainHeadersNames: [
    {
      text: '',
      cols: '4',
      id: 1,
    },
    {
      text: 'Assesor',
      cols: '3',
      id: 2,
      cellClass: 'with-divider-left',
    },
    {
      text: 'Treasurer',
      cols: '3',
      cellClass: 'with-divider-left',
      id: 3,
    },
    {
      text: '',
      cols: '0',
      cellClass: 'with-divider-left',
      id: 4,
    },
  ],
};
const RemitUnitHeaders = [
  {
    text: 'Remit Unit',
    value: 'remitUnit',
    sortable: true,
  },
  {
    text: 'Fund #',
    value: 'fundNumber',
    sortable: false,
  },
  {
    text: 'Name',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Address 1',
    value: 'address1',
    sortable: false,
  },
  {
    text: 'Address 2',
    value: 'address2',
    sortable: false,
  },
  {
    text: 'Address 3',
    value: 'address3',
    sortable: false,
  },
  {
    text: 'Email Address',
    value: 'emailAddress',
    sortable: false,
  },
  {
    text: 'Email Address 2',
    value: 'emailAddress2',
    sortable: false,
  },
  {
    text: 'Email Address 3',
    value: 'emailAddress3',
    sortable: false,
  },
  {
    text: 'ACH/EFT',
    value: 'achEft',
    sortable: false,
    align: 'center',
    formatter: 'flagToYorEmpty',
  },
];

export {
  TaxRollSummaryCollectionHeaders, MortgageCodesHeader, taxAdjTypesHeader, taxStatusCodesHeader,
  TaxStreetsHeaders, FeeTypesHeaders, TaxAdditionsHeaders, ProtestedTaxHeaders,
  tifDistrictsHeaders, newTaxRollHeaders, newTaxRollMainHeaders, RemitUnitHeaders,
  accessorXRefHeaders, mergeNFinalizeHeaders, assessorFireTaxXRefHeaders,
};
